export default {
  state: () => ({
    name: "Nupi",
    fullName: "Nupi Industrie Italiane S. p. A.",
    logoType: "png",
    partnerDescription:
      "Nupi Industrie Italiane S.p.A. – итальянский технологический конгломерат, объединивший в себе несколько концернов, имеющих своей целью создания мощного игрока на рынке пластикового трубопроката.<br>" +
      "С середины 90-х годов Nupi Industrie Italiane S.p.A. представляет на российском рынке высококлассный трубопрокат, активно применяемый как в нефти-газовом секторе, так и в области водоснабжения. <br>" +
      "С 2019 года ООО «ЕРС» является логистическим партнером Nupi Industrie Italiane S.p.A., осуществляя поставки 100% номенклатуры, производимой Nupi, для применения в нефти-газовом секторе Российской экономики.",
    positionInLogoArr: 2,
    styles: {
      xl: {
        imagePosition: {
          top: 30,
          right: 0
        }
      },
      l: {
        imagePosition: {
          top: 0,
          right: 0
        }
      },
      m: {
        imagePosition: {
          top: 50,
          right: 0
        }
      },
      s: {
        imagePosition: {
          top: 35,
          right: 0
        }
      }
    },
    products: [
      {
        name: "SingleWall",
        fullName: "Одностенный трубопровод для АЗС",
        desc:
          "Технология производства труб SMARTFLEX и&nbsp;ECOSMART основана на&nbsp;использовании полиэтилена ПНД (PEHD– PE100) с&nbsp;защитным&nbsp;слоем. Эти&nbsp;материалы, помимо гарантии долговечности и&nbsp;практических преимуществ для&nbsp;монтажника, представляют собой экономически выгодное решение по&nbsp;сравнению с&nbsp;традиционными материалами (металлами).<br />Одностенные многослойные трубопроводы SMARTFLEX и&nbsp;ECOSMART обладают превосходными свойствами ПНД (низкая проницаемость) и&nbsp;имеют высокую устойчивость к&nbsp;углеводородам технических полимеров нового&nbsp;поколения, из&nbsp;которых состоит внутренний барьерный слой, гарантируя надежность и&nbsp;долговечность при минимальных затратах, которых&nbsp;трудно достичь при&nbsp;использовании других материалов.<br />Первичная труба для&nbsp;топлива является многослойной, производится она посредством процесса коэкструзии (одновременная экструзия нескольких слоев из&nbsp;различных материалов). В&nbsp;ней сочетаются механические свойства полиэтилена высокой плотности с&nbsp;низкой проницаемостью и&nbsp;высокой химической устойчивостью внутренного или&nbsp;внешнего слоя из&nbsp;специально разработанного материала.",
        params: {
          "Сферы применения":
            "Автозаправочные станции<br />Заправочные станции в портах<br />Частные системы и цистерны для топлива",
          "Область применения":
            "Выдача<br />Слив<br />Деаэрация<br />Возврат паров RV1 и RV2",
          Долговечность: "Более 30 лет",
          "Стойкость к": "Нефтепродукты<br />Давление<br />Трение"
        }
      },
      {
        name: "DoubleWall",
        fullName: "Двустенный трубопровод для АЗС",
        desc:
          "Технология производства труб SMARTFLEX и&nbsp;ECOSMART основана на&nbsp;использовании полиэтилена ПНД (PEHD– PE100) с&nbsp;защитным&nbsp;слоем. Эти&nbsp;материалы, помимо гарантии долговечности и&nbsp;практических преимуществ для&nbsp;монтажника, представляют собой экономически выгодное решение по&nbsp;сравнению с&nbsp;традиционными материалами (металлами).<br />Двустенные многослойные трубопроводы SMARTFLEX и&nbsp;ECOSMART обладают превосходными свойствами ПНД (низкая проницаемость) и&nbsp;имеют высокую устойчивость к&nbsp;углеводородам технических полимеров нового&nbsp;поколения, из&nbsp;которых состоит внутренний барьерный слой, гарантируя надежность и&nbsp;долговечность, которых&nbsp;трудно достичь при&nbsp;использовании других материалов.<br />Второй контур трубопровода позволяет предоствратить утечки топлива в&nbsp;грунт даже при&nbsp;механическом повреждении участка трубопровода и вести мониторинг утечек.<br />Вторичная&nbsp;труба трубопроводов SMARTFLEX – это&nbsp;не&nbsp;просто защитный барьер, это&nbsp;полноценная полиэтиленовая труба, изготовленная из полиэтилена высокой&nbsp;плотности, и&nbsp;способная выдержать давление (или&nbsp;его&nbsp;падение) в&nbsp;системе автоматического мониторинга. Вторичная&nbsp;труба также&nbsp;может иметь&nbsp;внутренний барьерный слой в&nbsp;соответствии со&nbsp;стандартами различных стран или требованиями клиентов.",
        params: {
          "Сферы применения":
            "Автозаправочные станции<br />Заправочные станции в портах<br />Частные системы и цистерны для топлива<br />Снабжение топливом в аэропортах",
          "Область применения":
            "Выдача с контролем утечек<br />Слив<br />Деаэрация<br />Возврат паров RV1 и RV2",
          Долговечность: "Более 30 лет",
          "Стойкость к":
            "Нефтепродукты<br />Спирты<br />Растворители<br />Кислоты<br />Щёлочь<br />Давление<br />Трение"
        }
      },
      {
        name: "LPG",
        fullName: "Трубопровод для транспортировки газа",
        desc:
          "Пластиковый трубопровод для&nbsp;транспортировки газа SMARTlpg представляет собой термопластичный трубопровод, армированный полиэфирными волокнами. Он&nbsp;не&nbsp;гигроскопичен, биосовместим и&nbsp;полностью перерабатываемый. <br /> Качество используемых материалов и&nbsp;строгий контроль качества гарантируют его&nbsp;надежность на&nbsp;протяжении более&nbsp;50&nbsp;лет.<br /> Благодаря внутреннему барьерному слою из&nbsp;полиамида, трубопровод SMARTplg применяется для&nbsp;подземной транспортировки сжиженного углеводородного газа (СУГ&nbsp;/&nbsp;пропан-бутан) от&nbsp;резервуара к&nbsp;газораздаточной колонке&nbsp;(ГРК).",
        params: {
          "Область применения":
            "Выдача<br />Слив<br />Вентиляция<br />Отвод паров",
          "Рабочее давление": "35 бар",
          "Давление на разрыв": "200 бар",
          Долговечность: "50 лет",
          "Стойкость к": "СУГ<br />Коррозия<br />Трение"
        }
      }
    ]
  })
};
